import { useInvalidateMyDesigns } from '@/entities/my-design';
import { trpc } from '@/shared/api';

/** 내 디자인 바로 삭제(designs.delete) — 끝나면 목록을 다시 읽는다. 되돌릴 수 없다(2026-10-19 결정). */
export const useDeleteMyDesign = () => {
  const invalidate = useInvalidateMyDesigns();
  const mutation = trpc.designs.delete.useMutation();
  return {
    remove: async (designId: string): Promise<void> => {
      await mutation.mutateAsync({ id: designId });
      await invalidate();
    },
    isPending: mutation.isPending,
  };
};
